import { render } from "./my-messages.vue?vue&type=template&id=9ec7b180&scoped=true"
import script from "./my-messages.vue?vue&type=script&lang=js"
export * from "./my-messages.vue?vue&type=script&lang=js"

import "./my-messages.vue?vue&type=style&index=0&id=9ec7b180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ec7b180"]])

export default __exports__